import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { CreateNewShareMutation, CreateNewShareMutationVariables } from './createNewShare.graphql';
import { CreateNewShare } from './createNewShare.graphql';

export async function createNewShare(
	{ gql: { fetch } }: UtilityContext,
	petitionSlugOrId: string,
	channel: string,
	{
		silent,
	}: {
		// if true, won't throw on error
		silent?: boolean;
	} = {},
): Promise<void> {
	try {
		const { data } = await fetch<CreateNewShareMutation, CreateNewShareMutationVariables>({
			query: CreateNewShare,
			variables: {
				input: {
					petitionSlugOrId,
					channel,
				},
			},
			batched: false,
			rejectOnError: true,
		});

		if (data.createNewShareForViewer.__typename === 'CreateNewShareFailureResponse') {
			throw new Error('Failed to create new share');
		}
	} catch (e) {
		if (silent) return;
		throw e;
	}
}
